<template>
  <div class="detail-com">
    <el-descriptions title="" :column="1" border>
      <el-descriptions-item
        v-for="(item, key, idnex) in formData"
        :key="idnex"
        label-class-name="my-label"
        :label="item && item.label ? item.label : $t(`message.${key}`)"
      >
        <span v-if="item == 'slot'">
          <slot></slot>
        </span>
        <span v-else>{{ item && item.label ? item.value : item }}</span>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
export default {
  name: "DetailCom",
  props: {
    formData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.detail-com {
  padding: 0 20px;
  /deep/ img {
    max-width: 100%;
  }
}
</style>
<style lang="less">
.my-label {
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/DetailCom.vue